/* eslint-disable no-case-declarations */
/* eslint-disable react/jsx-no-constructed-context-values */
import { createContext, useContext, useReducer, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import ToastifyService from '../../../services/ToastifyService';
import UrlService from '../../../services/UrlService';

// Initial State
const initialState = {
    manufacturers: [],
};

// Reducer Function
const reducer = (state, action) => {
    switch (action.type) {
        case 'MANUFACTURER_LIST':
            return {
                ...state,
                manufacturers: action.payload,
            };
        case 'ADD_MANUFACTURER':
            return {
                ...state,
                manufacturers: [action.payload, ...state.manufacturers],
            };
        case 'EDIT_MANUFACTURER':
            const updateManufacturer = action.payload;

            const updatemanufacturers = state.manufacturers.map((manufacturer) => {
                if (manufacturer.id === updateManufacturer.id) {
                    return updateManufacturer;
                }
                return manufacturer;
            });
            return {
                ...state,
                manufacturers: updatemanufacturers,
            };

        default:
            return state;
    }
};

// Create Context
const ContextAPI = createContext(initialState);

export function useManufacturer() {
    return useContext(ContextAPI);
}

// Provider Component
export function ManufacturerProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [errMsg, setErrMsg] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    // Dependency
    const axiosPrivate = useAxiosPrivate();

    // API Function: Fatch All Data
    const getAllData = async () => {
        try {
            const response = await axiosPrivate.get(UrlService.getAllManufacturerUrl(), {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            dispatch({
                type: 'MANUFACTURER_LIST',
                payload: response?.data?.manufacturer_info,
            });
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Data Not Found!');
            }
        }
    };

    // API Function: Add/Edit Data
    const addOrUodateData = async (data, id) => {
        try {
            const response = await axiosPrivate.post(
                id ? UrlService.updateManufacturerUrl(id) : UrlService.saveManufacturerUrl(),
                JSON.stringify(data),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            await getAllData();
            await setShowModal(true);
            setIsSubmitted(true);

            if (response?.data?.status === 'error') {
                ToastifyService.errorNotify(response?.data?.message);
                setIsSubmitted(false);
            } else if (id != null) {
                ToastifyService.updateNotify('Data Update Successfull');
            } else {
                ToastifyService.saveNotify('Data Create Successfull');
            }
        } catch (err) {
            if (!err?.response) {
                setErrMsg('Server Not Responding!');
            } else if (err.response?.status === 401) {
                setErrMsg('Unauthorized!');
            } else if (id) {
                setErrMsg('Data Update Failed!');
            } else {
                setErrMsg('Data Insert Failed!');
            }
            ToastifyService.errorNotify(errMsg);
            setIsSubmitted(false);
        }
    };

    // Add Manufacturer
    const addManufacturer = (manufacturer) => {
        addOrUodateData(manufacturer);
        dispatch({
            type: 'ADD_MANUFACTURER',
            payload: manufacturer,
        });
    };

    // Edit Manufacturer
    const editManufacturer = (manufacturer, id) => {
        addOrUodateData(manufacturer, id);
        dispatch({
            type: 'EDIT_MANUFACTURER',
            payload: manufacturer,
        });
    };

    return (
        <ContextAPI.Provider
            value={{
                manufacturers: state.manufacturers,
                getAllData,
                addManufacturer,
                editManufacturer,
                showModal,
                isSubmitted,
                setIsSubmitted,
            }}
        >
            {children}
        </ContextAPI.Provider>
    );
}

export default ContextAPI;
